var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfraredMotionSensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,2.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "13.3,2.7 0.5,8 13.3,13.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,12.5c0.7-1.4,1.1-2.9,1.1-4.5s-0.4-3.2-1.1-4.5L0.5,8L11.4,12.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 14.5,
    cy: 4.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 14.5,
    cy: 11.2,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 14.8,
    cy: 8,
    r: 0.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfraredMotionSensor);
export default __webpack_public_path__ + "static/media/InfraredMotionSensor.7b4575e91e6dacf7028c59d4a746dd09.svg";
export { ForwardRef as ReactComponent };